import { forwardRef } from 'react';
import MuiDialogContent, { DialogContentProps as MuiDialogContentProps } from '@mui/material/DialogContent';
import { styled } from '@mui/material/styles';

export interface DialogContentProps extends MuiDialogContentProps {
  scrollable?: boolean;
}

const StyledDialogContent = styled(MuiDialogContent, {
  name: 'DialogContent',
  shouldForwardProp: (prop) => prop !== 'scrollable',
})<DialogContentProps>(({ scrollable }) => ({
  ...(scrollable && {
    overflowY: 'auto',
  }),
}));

const DialogContent = forwardRef<HTMLDivElement, DialogContentProps>((props, ref) => {
  return (
    <StyledDialogContent ref={ref} {...props}>
      {props.children}
    </StyledDialogContent>
  );
});

DialogContent.displayName = 'DialogContent';

export default DialogContent;
